export default "__VITE_ASSET__D$r52oC$__"